import linkSvg from 'assets/image/icons/tables/defaultLink.svg'
import editSvg from 'assets/image/icons/tables/edit.svg'
import clsx from 'clsx'
import TextFieldBig from 'components/atoms/TextFieldBig'
import TooltipCustom from 'components/atoms/tooltipCustom'
import { CONSTS } from 'config/objectConst'
import { importsAPI } from 'features/imports'
import { type FormEvent, memo, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { NotExistEntity } from 'shared/errors'
import { useSwitcher } from 'shared/hooks'
import { typo } from 'shared/styles'

import css from './Page.module.css'

const cnTitle = clsx(css.title, typo.subSection)

function EditMode({
	current,
	onCancel,
	onError
}: { current: string; onCancel: () => void; onError: () => void }) {
	const [name, setName] = useState(current)
	const { id = '' } = useParams<{ id?: string }>()
	const [update] = importsAPI.useUpdateMutation()

	function handleChange(event: FormEvent<HTMLInputElement>) {
		const value = event.currentTarget.value

		if (value.length <= CONSTS.IMPORT_MAX_LENGTH) {
			setName(value)
		}
	}

	function onFinish() {
		if (name === '' || name === current) {
			return onCancel()
		}

		onCancel()

		update({
			id,
			name
		})
			.unwrap()
			.catch(onError)
	}
	return (
		// @ts-ignore Broken types because of Premature Abstraction. Better use native input  or lib input directly
		<TextFieldBig
			autoFocus
			fullWidth
			onBlur={onFinish}
			onChange={handleChange}
			onEnter={onFinish}
			value={name}
		/>
	)
}

function RenameAble() {
	const editMode = useSwitcher(false)
	const { id = '' } = useParams<{ id?: string }>()

	const { data: info, isSuccess } = importsAPI.useImportByIdQuery(id, {
		skip: !id
	})

	const name = info?.name ?? ''
	const isNotExist = isSuccess && typeof info === 'string' && info === ''

	if (isNotExist) {
		throw new NotExistEntity(`Import with id '${id}' not exist`)
	}

	return (
		<header className={css.header}>
			{editMode.isOn ? (
				<EditMode
					current={name}
					onCancel={editMode.off}
					onError={editMode.on}
				/>
			) : (
				[
					<h1 className={cnTitle} key='💬'>
						{name}
					</h1>,
					<img
						alt='edit svg'
						className='edit-img'
						key='✏️'
						onClick={editMode.on}
						src={editSvg}
					/>
				]
			)}
			{info?.source_uri && (
				<a href={info.source_uri} rel='noopener noreferrer' target='_blank'>
					<TooltipCustom arrow title='origin'>
						<img alt='link svg' src={linkSvg} />
					</TooltipCustom>
				</a>
			)}
		</header>
	)
}

function Title_() {
	const { pathname } = useLocation()

	if (pathname === '/contacts') {
		return <h1 className={cnTitle}>All Contacts</h1>
	}

	if (pathname.includes('/import/')) {
		return <RenameAble />
	}

	return null
}

export const Title = memo(Title_)
